import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppComponent } from 'app/app.component';
import { AppDataService, ConfigService } from 'app/services';

@Component({
    selector: 'topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
    items: MenuItem[] = [];

    constructor(
        public app: AppComponent,
        private appData: AppDataService,
        public configService: ConfigService) {
    }

    ngOnInit(): void {
    }

    public logout(): boolean {
        this.appData.logout();

        return false;
    }
}
